export default {
    state: {},
  };
  